export const findUtilityById = (
  items: {
    text: string;
    value: number;
    utilityId: number;
    state: string;
    stateId: number;
    zipCode: string;
  }[],
  id: number
):
  | {
      text: string;
      value: number;
      utilityId: number;
      state: string;
      stateId: number;
      zipCode: string;
    }
  | undefined => {
  return items.find(item => item.value === id);
};
